<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import LocationCard from "./LocationCard.svelte";
  const currentYear = new Date().getFullYear();
</script>

<div class="w-full h-[2px] bg-blue-600 my-10"></div>

<div class="w-full py-8 md:py-12">
  <!-- Use full-width container + large horizontal padding on lg+ -->
  <div class="w-full px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32">
    <div
      class="flex flex-col-reverse md:flex-row md:justify-between md:items-baseline gap-6 md:gap-0"
    >
      <!-- Left: Locations -->
      <h1
        class="text-center md:text-left text-blue-900 font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight"
      >
        {$isEnglish ? "Our Locations" : "Ons Liggings"}
      </h1>

      <!-- Right: Emergency – clickable whole line -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <h1
        class="text-center text-blue-900 font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight
         cursor-pointer hover:text-blue-700 hover:underline underline-offset-4
         decoration-transparent hover:decoration-blue-700 transition-all duration-200
         whitespace-pre-line"
        on:click={() => (window.location.href = "tel:0631128693")}
      >
        {$isEnglish
          ? "Emergency After Hours:\n063 112 8693"
          : "Nood Na-Ure:\n063 112 8693"}
      </h1>
    </div>
  </div>
</div>

<div
  class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 justify-items-center mx-auto max-w-6xl items-start"
>
  <LocationCard
    title={$isEnglish
      ? "Vredenburg Veterinary Hospital"
      : "Vredenburg Dierehospitaal"}
    context={$isEnglish ? "Consultation Hours" : "Spreek Ure"}
    hourtext1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    hourtexttime1={`08:30 - 12:30
15:00 - 16:45`}
    hourtext2={$isEnglish ? "Saturday:" : "Saterdag:"}
    hourtexttime2="09:00 - 11:00"
    bsText={$isEnglish ? "Business Hours" : "Besigheids Ure"}
    bsDateText1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    bsDateTextTime1="08:00 - 16:45"
    bsDateText2={$isEnglish ? "Saturday:" : "Saterdag:"}
    bsDateTextTime2="09:00 - 11:00"
    addressText="56 Deur weg, Vredenburg, 7380"
    phoneNumber="022 715 1444"
    phoneDisplay="022 715 1444"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1674.7383066127597!2d17.979658852449447!3d-32.91200371271928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c34a139bc11ddc7%3A0x22561d75b0125b13!2sVredenburg%20Dierehospitaal!5e0!3m2!1saf!2sza!4v1701441290666!5m2!1saf!2sza"
  />

  <LocationCard
    title={$isEnglish
      ? "Langebaan Veterinary Hospital"
      : "Langebaan Dierehospitaal"}
    context={$isEnglish ? "Consultation Hours" : "Spreek Ure"}
    hourtext1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    hourtexttime1={`08:30 - 12:00
15:00 - 16:45`}
    hourtext2={$isEnglish ? "Saturday:" : "Saterdag:"}
    hourtexttime2="09:00 - 11:00"
    bsText={$isEnglish ? "Business Hours" : "Besigheids Ure"}
    bsDateText1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    bsDateTextTime1="08:00 - 16:45"
    bsDateText2={$isEnglish ? "Saturday:" : "Saterdag:"}
    bsDateTextTime2="09:00 - 11:00"
    addressText={$isEnglish
      ? "15 Sleigh street, Langebaan, 7380"
      : "15 Sleigh straat, Langebaan, 7380"}
    phoneNumber="022 772 1708"
    phoneDisplay="022 772 1708"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19845.870427790567!2d18.040497447274586!3d-33.07185669163953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c34aa017e6adae5%3A0xf38474b7af3fe7e!2sLangebaan%20Animal%20Hospital%20%26%20Vet%20Shop!5e0!3m2!1saf!2sza!4v1701442471408!5m2!1saf!2sza"
  />

  <LocationCard
    title={$isEnglish ? "Velddrif Animal Clinic" : "Velddrif Dierekliniek"}
    context={$isEnglish
      ? "Consultation Hours - Only By Appointment"
      : "Spreek Ure - Slegs Op Afsprake"}
    hourtext1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    hourtexttime1="08:00 - 09:00"
    bsText={$isEnglish ? "Business Hours" : "Besigheids Ure"}
    bsDateText1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    bsDateTextTime1="08:00 - 13:00"
    addressText={$isEnglish
      ? "4 Piet Orlam street, Velddrif, 7365"
      : "4 Piet Orlam straat, Velddrif, 7365"}
    phoneNumber="022 125 0541"
    phoneDisplay="022 125 0541"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6709.079776369777!2d18.154477300124743!3d-32.77794124465302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c3367ac15273983%3A0x8cd48675613d290f!2sVelddrif%20Dierekliniek!5e0!3m2!1saf!2sza!4v1701442418689!5m2!1saf!2sza"
  />

  <LocationCard
    title={$isEnglish ? "Saldanha Animal Clinic" : "Saldanha Dierekliniek"}
    context={$isEnglish ? "Consultation Hours" : "Spreek Ure"}
    hourtext1={$isEnglish ? "Tuesday & Thursday:" : "Dinsdag & Donderdag:"}
    hourtexttime1="14:00 - 15:00"
    addressText={$isEnglish
      ? "Tolken street, Saldanha, 7380"
      : "Tolken straat, Saldanha, 7380"}
    phoneNumber="022 714 4221"
    phoneDisplay="022 714 4221"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.5229040546473!2d17.942456269702916!3d-33.00135999834817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c34a5e02dcaf391%3A0x6923636ea928028f!2sSaldanha%20Veterinary%20Clinic!5e0!3m2!1saf!2sza!4v1701441627329!5m2!1saf!2sza"
  />

  <LocationCard
    title={$isEnglish ? "Agterbaai Animal Clinic" : "Agterbaai Dierekliniek"}
    context={$isEnglish
      ? "Consultation Hours - Only By Appointment"
      : "Spreek Ure - Slegs Op Afsprake"}
    hourtext1={$isEnglish
      ? "Monday, Wednesday & Friday:"
      : "Maandag, Woensdag en Vrydag:"}
    hourtexttime1="10:00 - 11:00"
    bsText={$isEnglish ? "Business Hours" : "Besigheids Ure"}
    bsDateText1={$isEnglish ? "Monday - Friday:" : "Maandag - Vrydag:"}
    bsDateTextTime1="08:00 - 13:00"
    addressText={$isEnglish
      ? "7 Shearwater St, St Helena Bay, 7390"
      : "7 Shearwater straat, St Helena Baai, 7390"}
    phoneNumber="022 125 0327"
    phoneDisplay="022 125 0327"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d209.71909334640594!2d18.011892934122972!3d-32.75231917748757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c349f59a125bbcd%3A0x16432a60da944982!2sDe%20Palm%20Lifestyle%20Centre!5e0!3m2!1saf!2sza!4v1715147954216!5m2!1saf!2sza"
  />

  <LocationCard
    title={$isEnglish ? "Hopefield Animal Clinic" : "Hopefield Dierekliniek"}
    context={$isEnglish ? "Consultation Hours" : "Spreek Ure"}
    hourtext1={$isEnglish ? "Tuesday & Thursday:" : "Dinsdag & Donderdag:"}
    hourtexttime1="08:00 - 09:00"
    addressText={$isEnglish
      ? "Fynbos Centre, Vredenburg street, Hopefield, 7380"
      : "Fynbos Sentrum, Vredenburg straat, Hopefield, 7380"}
    phoneNumber="022 723 0357"
    phoneDisplay="022 723 0357"
    mapsEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3343.8931042989507!2d18.33687287656268!3d-33.05928097758798!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c334b2ecea17ee1%3A0xbb9248344d2d879d!2sHopefield%20Dierekliniek!5e0!3m2!1saf!2sza!4v1780908534371!5m2!1saf!2sza"
  />
</div>

<div class="w-full h-[2px] bg-blue-600 my-10"></div>

<a
  href="https://www.rcl.za.net/"
  target="_blank"
  rel="noopener noreferrer"
  class="block text-center text-blue-900 font-bold text-sm tracking-tight no-underline hover:underline select-none touch-none"
>
  <h1 class="select-none">
    {$isEnglish
      ? `Website designed by RCL Technologies © ${currentYear}`
      : `Webblad ontwerp deur RCL Technologies © ${currentYear}`}
  </h1>
</a>
